import { CrmPage } from "types/crm/pagination";


export const toCrmPage = <T, C extends string = never>(
  payload: any,
  page: number,
  size: number,
): CrmPage<T, C> => {
  if (Array.isArray(payload)) {
    return {
      content: payload,
      page,
      size,
      totalElements: payload.length,
      totalPages: 1,
      last: true,
    };
  }

  const content: T[] = payload?.content ?? [];
  const totalPages = payload?.totalPages ?? 0;

  return {
    content,
    page: payload?.page ?? page,
    size: payload?.size ?? size,
    totalElements: payload?.totalElements ?? content.length,
    totalPages,
    last:
      payload?.last ??
      (totalPages ? page >= totalPages - 1 : content.length < size),
    counts: payload?.counts,
  };
};
